import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './_helpers';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: 'membresias',
        loadChildren: () => import('./membresia/membresia.module').then(m => m.MembresiaModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'eventos',
        loadChildren: () => import('./eventos/eventos.module').then(m => m.EventosModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'urgencias',
        loadChildren: () => import('./urgencias/urgencias.module').then(m => m.UrgenciasModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'solicitudDigital',
        loadChildren: () => import('./solicitud-digital/solicitud.module').then(m => m.SolicitudModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'presolicitud',
        loadChildren: () => import('./pasarela-pago/pasarela-pago.module').then(m => m.PasarelaPagoModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'estatusSolicitud',
        loadChildren: () => import('./asociado/asociado.module').then(m => m.AsociadoModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'solicitudes',
        loadChildren: () => import('./solicitudes/solicitudes.module').then(m => m.SolicitudesModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'agentes',
        loadChildren: () =>
          import('./agente/agente.module').then((m) => m.AgenteModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'promotorias',
        loadChildren: () =>
          import('./promotoria/promotoria.module').then(
            (m) => m.PromotoriaModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'odems',
        loadChildren: () =>
          import('./odem/odem.module').then((m) => m.OdemModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'usuarios',
        loadChildren: () =>
          import('./usuarios/usuario.module').then((m) => m.UsuarioModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'eventos',
        loadChildren: () => import('./eventos/eventos.module').then(m => m.EventosModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'cxp',
        loadChildren: () => import('./CXP/cxp.module').then((m) => m.CXPModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'cxc',
        loadChildren: () => import('./cxc/cxc.module').then((m) => m.CXCModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'comisiones',
        loadChildren: () =>
          import('./comisiones/comisiones.module').then(
            (m) => m.ComisionesModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'Catalogos',
        loadChildren: () =>
          import('./catalogos/catalogos.module').then(
            (m) => m.CatalogosModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'marketplace',
        loadChildren: () =>
          import('./marketplace/marketplace.module').then(
            (m) => m.MarketplaceModule
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'publico',
        loadChildren: () => import('./publico/publico.module').then(m => m.PublicoModule),
      },
    ],
  },
];

export class AppRoutingModule {}
